module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{".Layout_Join .SitePage_Join #customJoin":{"totalContentAllowed":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":".Layout_Join .SitePage_Join #customJoin","_fox_":1}],"widgets.total.widget":[{"value":"Widget","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":".Layout_Join .SitePage_Join #customJoin","_fox_":1}],"widgets.total.autoRender":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107006},"path":".Layout_Join .SitePage_Join #customJoin","_fox_":1}],"widgets.total.active":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":".Layout_Join .SitePage_Join #customJoin","_fox_":1}],"widgets.total.manualRender":[{"value":true,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":".Layout_Join .SitePage_Join #customJoin","_fox_":1}],"widgets.total.template":[{"value":"sitepage_join_total","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107009},"path":".Layout_Join .SitePage_Join #customJoin","_fox_":1}],"widgets.total.embed.container":[{"value":".total-content-wrapper","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107011},"path":".Layout_Join .SitePage_Join #customJoin","_fox_":1}],"widgets.total.handleWom.success.widget":[{"value":"@parent #totalApi","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107013},"path":".Layout_Join .SitePage_Join #customJoin","_fox_":1}],"widgets.total.handleWom.success.event":[{"value":"success","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107014},"path":".Layout_Join .SitePage_Join #customJoin","_fox_":1}],"widgets.total.handleWom.success.callback":[{"value":function (resp, api, e) {
var data = resp.answer.response
this.setTemplateOptions(data)
this.render()
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107019},"path":".Layout_Join .SitePage_Join #customJoin","_fox_":1}],"handleWom.onSubmit.callback":[{"value":function (userData) {
if (fox.Navigator.get(1) === 'step2' || fox.Navigator.get(0) === 'upgrade' || fox.getEnv('siteProps.freeJoin')) {
this.onSubmit(userData);
return;
}
this.rwom1('#form').validate().then(function (result) {
return result && fox.site.gotoPage('join/step2');
});
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107028},"path":".Layout_Join .SitePage_Join #customJoin","_fox_":1}]},".Layout_Join .SitePage_Join":{"hooks.onStartRendering":[{"value":function () {
var w = this.wom1('#customJoin');
var pm = this.wom1('@root #permissionManager');
if (pm && pm.hasAccess('guest') && !fox.isEmpty(pm.getMemberInfo())) {
w.setTemplateOptions('step2', true);
} else if (fox.Navigator.get(1) == 'step2') {
w.setTemplateOptions('step2', true);
} else {
w.setTemplateOptions('step2', false);
}
w.render();
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107040},"path":".Layout_Join .SitePage_Join","_fox_":1}],"handleWom.step_2.widget":[{"value":"@root #navi","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107042},"path":".Layout_Join .SitePage_Join","_fox_":1}],"handleWom.step_2.event":[{"value":"modified_1","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107043},"path":".Layout_Join .SitePage_Join","_fox_":1}],"handleWom.step_2.callback":[{"value":function (param, w, e) {
var w = this.wom1(' #customJoin');
if (!fox.isEmpty(param)) {
$('.steps', w.element[0]).addClass('show-step-2')
return;
};
$('.steps', w.element[0]).removeClass('show-step-2')
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107051},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.handleWom.togglePreloader.widget":[{"value":"#prepareTransactionApi","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107056},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.handleWom.togglePreloader.event":[{"value":["prepare","success","failure"],"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107057},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.handleWom.togglePreloader.callback":[{"value":function (obj, api, e) {
var el = $('.submit-btn')
if (e == 'prepare') {
el.addClass('spin');
return
}
el.removeClass('spin')
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107065},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.handleDom.nextPrev.target":[{"value":".arr","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107068},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.handleDom.nextPrev.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107069},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.handleDom.nextPrev.callback":[{"value":function (el) {
var slider = this.wom1('#joinOptions').swipe;
var dir = fox.dom.wrap(el).attr('data-direction');
if (dir == 'next') {
slider.next()
return;
}
slider.prev();
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107078},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.handleDom.gotoStep2.event":[{"value":"click","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107080},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.handleDom.gotoStep2.target":[{"value":".next-step","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107081},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.handleDom.gotoStep2.callback":[{"value":function (el, alias, w, e) {
return w.rwom1('#form').validate().then(function (result) {
return result && fox.site.gotoPage('join/step2');
});
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107086},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.handleDom.removeError.event":[{"value":"focus","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107088},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.handleDom.removeError.target":[{"value":"input[type=\"text\"], input[type=\"password\"]","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107089},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.handleDom.removeError.callback":[{"value":function (el, alias, w, e) {
var $node = $(el);
$node.parent().removeClass('error').next().text('').removeClass('show');
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107093},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.form.handleWom.activate.widget":[{"value":"@this","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107097},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.form.handleWom.activate.event":[{"value":"activate","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107098},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.form.handleWom.activate.callback":[{"value":function(obj, f, e) {
var w = fox.wom.selectFirst('@root #joinFormStep1');
this.wait(f, 'form_ready').then(() => {
fox.each(w.getValues(), function (val, alias) {
var checkValue = val !== undefined ? val : '';
f.setValue(alias, checkValue);
}, this)
})
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107107},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.pager.widget":[{"value":"Widget","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107109},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.pager.container":[{"value":".bullets","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107110},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.pager.autoRender":[{"value":false,"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107111},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.pager.template":[{"value":"sitepage_join_form_pager","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107112},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.pager.handleDom.onclick.target":[{"value":"[data-idx]","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107114},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.pager.handleDom.onclick.callback":[{"value":function (el) {
var idx = el.getAttribute('data-idx');
var joinOptions = this.rwom1('@parent #joinOptions');
joinOptions.swipe.slide(idx);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107119},"path":".Layout_Join .SitePage_Join","_fox_":1}],"widgets.customJoin.widgets.joinOptions.hooks.onStopAddedToDom":[{"value":function () {
var options = fox.getEnv('siteProps.ubs.joinOptions.options');
var pager = this.getParent().rwom1('#pager')
var arr = [];
var w = this;
var i;
var maxDiscount = this.getOption('maxDiscount');
var discountPosition = false;
fox.each(options, function (opt, n) {
data = {i: n};
if (fox.Navigator.get(0) == 'upgrade' && !!(opt.discountParams.length > 0)){
var curDiscount = Math.trunc(opt.discountParams.discount);
if (curDiscount == maxDiscount){
discountPosition = n;
i = n;
data.active = true;
var form = w.rwom1('@parent #form');
var chkbx = fox.dom.selectFirst('#joinOption_' + opt.id);
if (!form.ready) {
arr.push(data);
return w.getParent().wait(form, 'form_ready').then(function () {
form.setValue(chkbx.name, chkbx.value);
});
} else {
form.setValue(chkbx.name, chkbx.value);
}
}
} else {
if (opt['default']) {
i = n;
data.active = true
}
}
arr.push(data);
});
this.swipe = (Swipe)(w.getParent().dom1('#swipe'), {
startSlide: i,
callback: function (ind, el) {
var arr = [];
var chkbx = fox.dom.selectFirst('input[type="radio"]', el);
w.rwom1('@parent #form').setValue(chkbx.name, chkbx.value);
fox.each(options, function (opt, n) {
var data = {i: n};
if (opt.settings.id == chkbx.value) {
data.active = true
}
arr.push(data)
});
pager.setTemplateOptions({bullets: arr}).render()
}
});
if(!!discountPosition){
this.swipe.slide(discountPosition, 0)
}
pager.setTemplateOptions({bullets: arr}).render()
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107178},"path":".Layout_Join .SitePage_Join","_fox_":1}],"handleWom.formIsEmpty.event":[{"value":"form_not_valid","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107181},"path":".Layout_Join .SitePage_Join","_fox_":1}],"handleWom.formIsEmpty.widget":[{"value":"#customJoin #form","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107182},"path":".Layout_Join .SitePage_Join","_fox_":1}],"handleWom.formIsEmpty.callback":[{"value":function (infos) {
fox.each(infos, function (info) {
if (info.result === true)
return false;
var $node = $(this.dom1('[name="' + info.field + '"]'));
$node.parent().next().text(info.message).addClass('show');
if (fox.inArray(['login', 'email'], info.field)) {
fox.site.gotoPage('join')
}
}, this);
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107193},"path":".Layout_Join .SitePage_Join","_fox_":1}],"handleWom.errorOnPrepare.event":[{"value":"onPrepareFailed","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107195},"path":".Layout_Join .SitePage_Join","_fox_":1}],"handleWom.errorOnPrepare.params.prefix":[{"value":"error","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107196},"path":".Layout_Join .SitePage_Join","_fox_":1}],"handleWom.errorOnPrepare.widget":[{"value":"#customJoin","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107197},"path":".Layout_Join .SitePage_Join","_fox_":1}],"handleWom.errorOnPrepare.callback":[{"value":function (params, performer) {
var form, fEl, lError, code;
form = performer.rwom1('#form');
code = params.code;
if (fox.isEmpty(params.data) && !fox.isSet(code)) {
params.data = {
username: [
{message: params.reason}
]
}
}
switch (code) {
case 12:
params.data = {
email: [
{ message: params.reason }
]
}
break;
case 2:
params.data = {
username: [
{ message: 'User with such login already exists' }
]
}
break;
}
fox.each(params.data, function (val, key) {
if (key === 'username') {
key = 'login';
}
var fEl = form.getElement(key).getNodes()[0];
var lError = jQuery(fEl).parent().next();
lError.text(val[0].message).addClass('show');
if (fEl) {
fox.dom.addClass('error', fEl.parentNode);
}
});
fox.site.gotoPage('join');
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107237},"path":".Layout_Join .SitePage_Join","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/sitepage/join.js
// module id = 1031
// module chunks = 4